export default {
  // Catalogo

  GET_CATEGORIAS: 'Categoria/categorias',
  GET_CATEGORIAS_CHILD: 'Categoria/categoriasChildren',
  GET_CATEGORIAS_FILTERED: 'Categoria/categorias/filtered',
  GET_SUBCATEGORIAS: 'Categoria/categorias/subcategorias',
  GET_CATEGORIA_BY_ID: 'Categoria/categorias',
  PUT_CATEGORIA_UPDATE: 'Categoria/categorias',
  POST_CATEGORIA_INSERT: 'Categoria/categorias',
  DELETE_CATEGORIA_BY_ID: 'Categoria',
  DELETE_CATEGORIAS_BY_IDS: 'Categoria/categorias/deleteList',
  POST_REMOVE_CACHE_CATEGORIA: 'Categoria/categorias/removeCache',
  LIMPIAR_CACHE_CATEGORIA_IDS: 'Categoria/categorias/limpiarCacheCategoriaIds',

  GET_CATEGORIA_PERSOALIZADOS: 'CategoriaPersonalizado/categoriaPersonalizados',
  PUT_CATEGORIA_PERSONALIZADOS_UPDATE: 'CategoriaPersonalizado/categoriaPersonalizados',

  GET_PRODUCTOS: 'Producto/productos/filtered',
  GET_PRODUCTO_BY_ID: 'Producto/productos',
  GET_PRODUCTOS_BY_ID: 'Producto/productosByIds',
  PUT_PRODUCTO_UPDATE: 'Producto/productos',
  POST_PRODUCTO_INSERT: 'Producto/productos',
  PATCH_PRODUCTO_UPDATE: 'Producto/productos',
  DELETE_PRODUCTO_BY_ID: 'Producto',
  DELETE_PRODUCTOS_BY_IDS: 'Producto/productos/deleteList',
  GET_PRECIO_PRODUCTO: 'Producto/precioProducto',
  GET_PRODUCTOS_AVATARES: 'Producto/productoAvatares',
  GET_PRODUCTO_INFO_DESCARGA: 'Producto/infoDescarga',

  GET_PRODUCTOS_ORDENACION_CATEGORIA_BY_IDIOMA_ID: 'Producto/productos/getAllCategoriaByIdiomaId',
  PATCH_PRODUCTOS_ORDENACION_CATEGORIA_GUARDAR_POSICIONES: 'Producto/productos/ordernarProductos',

  GET_RECUPERAR_LISTA_PRODUCTOS_ELIMINADOS: 'Producto/productos/recuperarProductosEliminadosList',
  PATCH_ACTIVAR_PRODUCTOS_ELIMINADOS: 'Producto/productos/activarProductosEliminados',
  PATCH_CAMBIAR_CATEGORIA_PERSONALIZADA_PRODUCTO:
    'Producto/productos/cambiarCategoriaPersonalizada',

  PRODUCTO_GENERICO: 'ProductoGenerico/ProductoGenerico',
  PRODUCTO_GENERICO_ROOT: 'ProductoGenerico',

  GET_PRODUCTO_GENERICO_BOCETO: 'productoGenericoBoceto/productoGenericoBoceto/filtered',
  PRODUCTO_GENERICO_BOCETO: 'productoGenericoBoceto/productoGenericoBoceto',
  PUT_PRODUCTO_GENERICO_BOCETO_POSICION:
    'productoGenericoBoceto/productoGenericoBoceto/UpdateAreas',
  GET_FONDO_PRODUCTO_GENERICO_BOCETO_POSICION:
    'productoGenericoBoceto/productoGenericoBoceto/getBocetoFile',

  GET_PRODUCTOS_ADICIONALES_BY_IDIOMA_ID: 'ProductoAdicional/productoAdicionales/GetAllByIdiomaId',
  PATCH_PRODUCTOS_ADICIONALES_GUARDAR_ORDENACION:
    'ProductoAdicional/productoAdicionales/ordernarProductosAdicionales',

  PUT_PRODUCTOS_BIBILIOTECAPRECIOS_UPDATE: 'Producto/productos/setbibliotecaprecioid',

  GET_IVAS: 'Iva/iva',
  GET_IVA_DESCRIPCIONES: 'IvaDescripcion/ivadescripciones',
  POST_IVA_DESCRIPCIONES: 'IvaDescripcion/ivadescripciones',
  PUT_IVA_DESCRIPCIONES: 'IvaDescripcion/ivadescripciones',
  DELETE_IVA_DESCRIPCIONES: 'IvaDescripcion/ivadescripciones',

  GET_MAPAS: 'Mapa/mapas',

  GET_URLS: 'Url/urls',
  GET_URLS_BY_CATEGORIA: 'Url/urls/categoria',
  GET_URLS_BY_CATEGORIA_WITH_URL_GRUPO: 'Url/urls/categoriaWithUrlGrupo',
  GET_URLS_FILTERED: 'Url/urls/filtered',
  GET_URLS_FILTERED_REDUCED: 'Url/urls/filtered/reduced',
  GET_URL_BY_ID: 'Url/urls',
  PUT_URL_UPDATE: 'Url/urls',
  POST_URL_INSERT: 'Url/urls',
  DELETE_URL_BY_ID: 'Url',
  DELETE_URLS_BY_IDS: 'Url/urls/deleteList',
  PUT_URL_CARTEL_UPDATE: 'Url/urls/updateUrlsCarteles',
  GET_URLS_BY_GRUPO: 'Url/urls/urlGrupo',
  PUT_SORT_URLS_URL_GRUPO_UPDATE: 'Url/urls/ordenarUrlGruposUrl',
  PUT_DESASOCIAR_URLS_URL_GRUPO_UPDATE: 'Url/urls/desasociarUrlGrupoUrl',
  PUT_ASOCIAR_URLS_URL_GRUPO_UPDATE: 'Url/urls/asociarUrlaUrlGrupo',
  PUT_NOGRUPO_URLS_URL_GRUPO_UPDATE: 'Url/urls/setNoGrupoUrlGruposUrl',
  SET_MOSTRARCANTIDAD_URL: 'uRL/mostrar-cantidad',
  DUPLICAR_URL: 'Url/urls/duplicar',
  DUPLICAR_PRODUCTOS_URL: 'Url/urls/duplicarProductos',
  REACTIVAR_URLS: 'Url/urls/reactivarUrls',
  GET_URLS_DELETED: 'Url/urls/deleted',
  GET_URLS_ACTIVADAS_NO_TRADUCIDAS: 'Url/urls/urlActivasNoTraducidas',
  CAMBIAR_CATEGORIA_URL: 'Url/urls/cambiarCategoriaProductosUrl',
  LIMPIAR_CACHE_URL: 'Url/urls/limpiarCacheUrl',

  GET_URLS_ADICIONALES: 'UrlAdicional/urladicionalesByUrlId',
  PUT_URLS_ADICIONALES_UPDATE: 'UrlAdicional/urladicionales',

  GET_ALL_MULTIMEDIA_BY_URL_ID: 'MultimediaUrl/multimediaUrl/getAllByUrlId',
  POST_MULTIMEDIA_URL_FILTERED: 'MultimediaUrl/multimediaUrl/filtered',
  POST_MULTIMEDIA_URL_INSERT: 'MultimediaUrl/multimediaUrl',
  PUT_MULTIMEDIA_URL: 'MultimediaUrl/multimediaUrl',
  DELETE_MULTIMEDIA_URL: 'MultimediaUrl',

  GET_URL_MULTIMEDIA_URL_BY_MULTIMEDIAID:
    'UrlMultimediaUrl/urlMultimediaUrl/getAllUrlByUrlMutimediaIds',
  POST_URL_MULTIMEDIA_URL_INSERT_MASIVO: 'UrlMultimediaUrl/urlMultimediaUrl/insertMasivo',
  PUT_URL_MULTIMEDIA_URL_UPDATE_MASIVO: 'UrlMultimediaUrl/urlMultimediaUrl/updateMasivo',
  DELETE_URL_MULTIMEDIA_URL: 'UrlMultimediaUrl/urlMultimediaUrl',
  DELETE_URL_MULTIMEDIA_URL_BY_MULTIMEDIA_ID:
    'UrlMultimediaUrl/urlMultimediaUrl/deleteAllByMultimediaId',

  GET_URLS_FOTOS: 'UrlFoto/urlFotossByUrlId',
  POST_URL_FOTO_INSERT: 'UrlFoto/urlFotos',
  UPDATE_URL_FOTO_INSERT: 'UrlFoto',
  DELETE_URL_FOTO_BY_ID: 'UrlFoto',
  POST_URLS_FOTOS_SORT_ITEMS_UPDATE: 'UrlFoto/urlFotos/sort',

  GET_URL_GRUPOS: 'UrlGrupo/urlGrupos',
  GET_URL_GRUPOS_BY_TYPE: 'UrlGrupo/urlGrupos',
  PUT_URL_GRUPO_UPDATE: 'UrlGrupo/urlGrupos',
  POST_URL_GRUPO_INSERT: 'UrlGrupo/urlGrupos',
  GET_URL_GRUPO_BY_ID: 'UrlGrupo',
  DELETE_URL_GRUPO_BY_ID: 'UrlGrupo',

  GET_CARTELES: 'Cartel/carteles',
  GET_CARTEL_BY_ID: 'Cartel/carteles',
  PUT_CARTEL_UPDATE: 'Cartel/carteles',
  POST_CARTEL_INSERT: 'Cartel/carteles',
  DELETE_CARTEL_BY_ID: 'Cartel',

  GET_FECHAS_SENALADAS: 'FechaSenalada/fechaSenaladas',
  GET_FECHA_SENALADA_BY_ID: 'FechaSenalada/fechaSenaladas',
  PUT_FECHA_SENALADA_UPDATE: 'FechaSenalada/fechaSenaladas/list',
  POST_FECHA_SENALADA_INSERT: 'FechaSenalada/fechaSenaladas',
  PUT_FECHA_SENALADA_UPDATE_ALL: 'FechaSenalada/fechaSenaladas',
  DELETE_FECHA_SENALADA_BY_ID: 'FechaSenalada',

  GET_FECHAS_SENALADAS_URL_BY_ID: 'FechaSenaladaUrl/fechaSenaladaUrlsByFechaId',
  GET_FECHAS_SENALADAS_URL_SORT_IMAGES_BY_ID: 'FechaSenaladaUrl/fechaSenaladaUrls/sortImages',
  POST_FECHAS_SENALADAS_URL_INSERT: 'FechaSenaladaUrl/fechaSenaladaUrls',
  DELETE_FECHA_SENALADA_URL_BY_ID: 'FechaSenaladaUrl',
  PUT_FECHA_SENALADA_URL_UPDATE: 'FechaSenaladaUrl/fechaSenaladaUrls/list',
  POST_FECHA_SENALADA_URL_SORT_IMAGES_UPDATE: 'FechaSenaladaUrl/fechaSenaladaUrls/sort',

  GET_ETIQUETAS_BY_PADREID: 'Etiqueta/etiquetasByPadreId',
  GET_ETIQUETAS_ALL: 'Etiqueta/etiquetas',
  DELETE_ETIQUETA_BY_ID: 'Etiqueta',
  POST_ETIQUETA_SORT_ITEMS_UPDATE: 'Etiqueta/etiquetas/sort',
  GET_ETIQUETA_BY_ID: 'Etiqueta/etiquetas',
  POST_ETIQUETA_INSERT: 'Etiqueta/etiquetas',
  PUT_ETIQUETA_UPDATE: 'Etiqueta/etiquetas',
  POST_REMOVE_CACHE_ETIQUETA: 'Etiqueta/etiquetas/removeCache',

  POST_ETIQUETA_URL_INSERT: 'EtiquetaUrl/etiquetaUrls',
  GET_ETIQUETAS_URL_BY_ID: 'EtiquetaUrl/etiquetaUrlsByEtiquetaId',
  DELETE_ETIQUETA_URL_BY_ID: 'EtiquetaUrl',
  PUT_ETIQUETA_URL_UPDATE: 'EtiquetaUrl/etiquetaUrls/list',
  PUT_ETIQUETA_URL_BULK_UPDATE_ORDER: 'EtiquetaUrl/etiquetaUrls/bulk-update-order',
  POST_ETIQUETA_URL_SORT_UPDATE: 'EtiquetaUrl/etiquetaUrls/sort',

  GET_ARTICULOS: 'Articulo/articulos',
  GET_ARTICULOS_FILTERED: 'Articulo/articulos/filtered',
  GET_ARTICULOS_VENDIDOS: 'Producto/articulos/vendidos',
  POST_ARTICULO_INSERT: 'Articulo/articulos',
  PUT_ARTICULO_UPDATE: 'Articulo/articulos',
  PUT_ARTICULO_STOCK_UPDATE: 'Articulo/articuloStock',
  DELETE_ARTICULO_BY_ID: 'Articulo',
  GET_ARTICULO_BY_ID: 'Articulo/articulos',
  GET_ARTICULOS_FALTANTES: 'Articulo/articulosStockMinimo',
  PUT_ARTICULO_USER: 'Articulo/articuloUser',
  PUT_ARTICULO_USER_MOSTRAR: 'Articulo/articuloUserMostrar',
  PUT_ARTICULO_AGOTAR: 'Articulo/articuloAgotar',
  POST_ARTICULO_STOCK_AJUSTE: 'Producto/articulos/ajusteStock',  

  GET_ARTICULOS_PRODUCTOS_BY_ARTICULO_ID: 'ArticuloProducto/articuloProductosByArticuloId',
  DELETE_ARTICULO_PRODUCTO_BY_ID: 'ArticuloProducto',
  POST_ARTICULOS_PRODUCTOS_INSERT: 'ArticuloProducto/articulosProductosList',

  GET_HISTORIAL_STOCKS_TOP: 'Producto/articulos/historialStock',
  POST_HISTORIAL_STOCK_INSERT: 'HistorialStock/historialStocks',
  PUT_HISTORIAL_STOCK_UPDATE: 'HistorialStock/historialStocks',
  DELETE_HISTORIAL_STOCK_BY_ID: 'HistorialStock',

  GET_FRUTAS_ALL: 'Fruta/frutas',
  POST_FRUTA_INSERT: 'Fruta/frutas',
  PUT_FRUTA_UPDATE: 'Fruta/frutas',
  DELETE_FRUTA_BY_ID: 'Fruta',
  POST_GET_PRODUCTO_FRUTAS_SUMA_CANTIDAD: 'ProductoFruta/getSumaCantidadProductoFrutas',

  GET_PROVEEDORES: 'Proveedor/proveedores',
  POST_PROVEEDOR_INSERT: 'Proveedor/proveedores',
  PUT_PROVEEDOR_UPDATE: 'Proveedor/proveedores',
  DELETE_PROVEEDOR_BY_ID: 'Proveedor',
  GET_PROVEEDOR_BY_ID: 'Proveedor/proveedores',

  // Logistica Pedido

  GET_PROVINCIAS: 'Provincia/provincias',
  GET_PROVINCIAS_ROOT: 'Provincia',
  PUT_PROVINCIA_UPDATE: 'Provincia/provincias',

  GET_FECHAS_NO_ENTREGA: 'FechaNoEntrega/fechasNoEntrega',
  GET_FECHA_NO_ENTREGA_BY_ID: 'FechaNoEntrega/fechasNoEntrega',
  GET_FECHAS_NO_ENTREGA_PROVINCIA: 'FechaNoEntregaProvincia/fechasNoEntregaProvinciaByFechaId',
  POST_FECHA_NO_ENTREGA_INSERT: 'FechaNoEntrega/fechasNoEntrega',
  PUT_FECHA_NO_ENTREGA_UPDATE: 'FechaNoEntrega/fechasNoEntrega',
  DELETE_FECHA_NO_ENTREGA_BY_ID: 'FechaNoEntrega',
  PUT_FECHA_NO_ENTREGA_PROVINCIA_UPDATE: 'FechaNoEntregaProvincia/fechasNoEntregaProvincia',
  DELETE_FECHAS_NO_ENTREGA_PROVINCIA_BY_FECHA_ID: 'FechaNoEntregaProvincia/deleteByFechaId',
  GET_FECHAS_NO_ENTREGA_CATEGORIA_PERSO:
    'FechaNoEntregaCategoriaPersonalizado/fechasNoEntregaCategoriaPersonalizadoByFechaId',
  PUT_FECHA_NO_ENTREGA_CATEGORIA_PERSO_UPDATE:
    'FechaNoEntregaCategoriaPersonalizado/fechasNoEntregaCategoriaPersonalizado',
  DELETE_FECHAS_NO_ENTREGA_CATEGORIA_PERSO_BY_FECHA_ID_CATEGORIA_ID:
    'FechaNoEntregaCategoriaPersonalizado/deleteByFechaIdAndCategoriaPersoId',
  GET_FECHAS_NO_ENTREGA_CATEGORIA_PERSO_DIA:
    'CategoriaPersonalizadoDia/categoriaPersonalizadoDiasByDiaId',
  PUT_FECHA_NO_ENTREGA_CATEGORIA_PERSO_DIA_UPDATE:
    'CategoriaPersonalizadoDia/categoriaPersonalizadoDias',
  DELETE_FECHAS_NO_ENTREGA_CATEGORIA_PERSO_DIA_BY_DIA_ID: 'CategoriaPersonalizadoDia/deleteByDiaId',
  GET_FECHAS_NO_ENTREGA_DIA: 'Dia/dias',
  PUT_FECHA_NO_ENTREGA_DIA_UPDATE: 'Dia/dias',
  GET_FECHAS_NO_ENTREGA_CONFIGURACION_CATEGORIA: 'ConfiguracionCategoria/configuracionCategorias',
  PUT_FECHA_NO_ENTREGA_CONFIGURACION_CATEGORIA_UPDATE:
    'ConfiguracionCategoria/configuracionCategorias',

  GET_FECHAS_BLOQUEADAS: 'FechaBloqueada/fechasBloqueadas',
  POST_FECHA_BLOQUEADA_INSERT: 'FechaBloqueada/fechasBloqueadas',
  PUT_FECHA_BLOQUEADA_UPDATE: 'FechaBloqueada/fechasBloqueadas',
  DELETE_BLOQUEADA_BY_ID: 'FechaBloqueada',

  GET_FECHAS_BLOQUEADAS_PROVINCIA: 'FechaBloqueadaProvincia/fechasBloqueadasProvinciaByFechaId',
  PUT_FECHA_BLOQUEADA_PROVINCIA_UPDATE: 'FechaBloqueadaProvincia/fechasBloqueadasProvincia',
  DELETE_FECHAS_BLOQUEADAS_PROVINCIA_BY_FECHA_ID: 'FechaBloqueadaProvincia/deleteByFechaId',

  GET_FRANJAS_HORARIOS: 'LimitarHorario/limitarHorarios',
  POST_FRANJA_HORARIO_INSERT: 'LimitarHorario/limitarHorarios',
  PUT_FRANJA_HORARIO_UPDATE: 'LimitarHorario/limitarHorarios',
  DELETE_FRANJA_HORARIO_BY__ID: 'LimitarHorario',
  GET_FRANJA_HORARIO_BY_ID: 'LimitarHorario/limitarHorarios',

  DELETE_FRANJA_HORARIO_RANGO_BY_ID: 'LimitarHorarioRango',
  POST_FECHA_HORARIO_INSERT: 'LimitarHorarioRango/limitarHorariosRango',
  PUT_FRANJA_HORARIO_EDITAR_UPDATE: 'LimitarHorarioRango/limitarHorariosRango',

  GET_UBICACIONES_HORARIOS_BY_FECHA: 'Ubicacion/ubicacionesByFecha',
  GET_FRANJAS_HORARIOS_EDITAR: 'Ubicacion/ubicacionesByLimitarHorarioId',
  GET_UBICACIONES: 'Ubicacion/ubicaciones',
  GET_UBICACIONES_ETREGA_NO_ESPECIAL: 'Ubicacion/ubicacionesWithHorariosEntregaNoEspecial',
  GET_UBICACIONES_MRW: 'Ubicacion/ubicacionesHorariosEntregaMRW',

  GET_DIAS_ESPECIALES: 'DiaEspecial/diasEspeciales',
  POST_DIA_ESPECIAL_INSERT: 'DiaEspecial/diasEspeciales',
  PUT_DIA_ESPECIAL_UPDATE: 'DiaEspecial/diasEspeciales',
  DELETE_DIA_ESPECIAL_BY_ID: 'DiaEspecial',
  GET_DIAS_ESPECIALES_EDITAR: 'DiaEspecial/diasEspecialesByDiaEspecialId',
  GET_DIA_ESPECIAL_BY_ID: 'DiaEspecial/diasEspeciales',
  POST_DIA_ESPECIAL_DUPLICAR: 'DiaEspecial/duplicar',

  DELETE_DIA_ESPECIAL_EDITAR: 'HorarioEntrega',
  POST_DIA_ESPECIAL_EDITAR_INSERT: 'HorarioEntrega/horariosEntregaAndHorariosEntregaEspecial',
  PUT_DIA_ESPECIAL_EDITAR_UPDATE: 'HorarioEntrega/horariosEntregaAndHorariosEntregaEspecial',

  GET_CONFIGURACION_CASO3_BIS: 'ConfiguracionCaso3Bis/configuracionescaso3BisWithHorarioEntrega',
  DELETE_CONFIGURACION_CASO3_BIS_BY_ID: 'ConfiguracionCaso3Bis',
  PUT_CONFIGURACION_CASO3_BIS_UPDATE: 'ConfiguracionCaso3Bis/configuracionescaso3Bis',
  POST_CONFIGURACION_CASO3_BIS_INSERT: 'ConfiguracionCaso3Bis/configuracionescaso3Bis',

  GET_CONFIGURACION_CASO3: 'ConfiguracionCaso3/configuracionescaso3WithHorarioEntrega',
  PUT_CONFIGURACION_CASO3_UPDATE: 'ConfiguracionCaso3/configuracionescaso3',
  POST_CONFIGURACION_CASO3_INSERT: 'ConfiguracionCaso3/configuracionescaso3',

  GET_CPS_CONFLICTIVOS: 'CodigoPostalConflictivoMRW/codigosPostalesConflictivoMRW',
  POST_CP_CONFLICTIVO_INSERT: 'CodigoPostalConflictivoMRW/codigosPostalesConflictivoMRW',
  PUT_CP_CONFLICTIVO_UPDATE: 'CodigoPostalConflictivoMRW/codigosPostalesConflictivoMRW',

  GET_PAISES: 'Pais/paises',
  GET_PAISES_ROOT: 'Pais',
  POST_PAIS_INSERT: 'Pais/paises',
  PUT_PAIS_UPDATE: 'Pais/paises',
  DELETE_PAIS_BY_ID: 'Pais',

  GET_CP_INTERNACIONALES: 'CodigoPostalInternacional/codigosPostalesInternacionalesByPaisId',
  POST_CP_INTERNACIONAL_INSERT: 'CodigoPostalInternacional/codigosPostalesInternacionales',
  PUT_CP_INTERNACIONAL_UPDATE: 'CodigoPostalInternacional/codigosPostalesInternacionales',
  DELETE_CP_INTERNACIONAL_BY_ID: 'CodigoPostalInternacional',

  GET_ALL_HORARIOS_ENTREGA: 'HorarioEntrega/horariosEntregaMostrarTodo',
  GET_ALL_HORARIOS_ENTREGA_BY_UBICACION_ID: 'HorarioEntrega/cargarUbicacionesAdmin',
  GET_HORARIO_ENTREGA_ES_FECHA_ESPECIAL: 'HorarioEntrega/horariosEntregaEsFechaEspecial',
  GET_HORARIOS_ENTREGA_MADRID_BY_UBICACION_ID:
    'HorarioEntregaMadrid/horariosEntregaMadridByUbicacionId',
  POST_HORARIO_ENTREGA_MADRID_INSERT: 'HorarioEntregaMadrid/horariosEntregaMadrid',
  PUT_HORARIO_ENTREGA_MADRID_UPDATE: 'HorarioEntregaMadrid/horariosEntregaMadrid',
  DELETE_HORARIO_ENTREGA_MADRID_BY_ID: 'HorarioEntregaMadrid',
  GET_HORARIO_ENTREGA_BY_ID: 'HorarioEntrega/horariosEntrega',

  GET_CPS: 'CodigoPostal/codigosPostalesFiltered',
  GET_TIPOS_CPS: 'CodigoPostal/codigosPostalesTipos',
  POST_CP_INSERT: 'CodigoPostal/codigosPostales',
  PUT_CP_UPDATE: 'CodigoPostal/codigosPostales',
  DELETE_CP_BY_ID: 'CodigoPostal',

  GET_CPS_RESTRICCIONES_MOVILIDAD: 'CodigoPostalRestriccionesMovilidad',

  GET_PAGINA_OK_TEMPLATE_BY_ID: 'PaginaOkTemplate/paginasOkTemplate',
  GET_PAGINA_OK_SECCION_WHATSAPP: 'PaginaOkSeccion/mensajesWhatsApp',
  PUT_PAGINA_OK_TEMPLATE: 'PaginaOkTemplate/paginasOkTemplate',

  GET_SECCION_TEMPLATE_BY_ID: 'PaginaOkSeccion/paginasOkSeccion',
  PUT_SECCION_TEMPLATE: 'PaginaOkSeccion/paginasOkSeccion',

  GET_FORMAS_PAGO: 'FormaPago/formaspago',

  GET_ESTADOS: 'Estado/estados',
  GET_ESTADOS_MENSAJERIA: 'EstadoMensajeria/estadosMensajeria',

  GET_FECHAS_COLOR: 'FechaColor/fechasColor',
  POST_FECHA_COLOR_INSERT: 'FechaColor/fechasColor',
  PUT_FECHA_COLOR_UPDATE: 'FechaColor/fechasColor',
  DELETE_COLOR_BY_ID: 'FechaColor',

  GET_DHL_DESCRIPCIONES: 'DhlDescripcion/dhlDescripciones',
  POST_DHL_DESCRIPCION_INSERT: 'DhlDescripcion/dhlDescripciones',
  DELETE_DHL_DESCRIPCION_BY_ID: 'DhlDescripcion',

  POST_ESTADO_INSERT: 'Estado/estados',
  PUT_ESTADO_UPDATE: 'Estado/estados',
  DELETE_ESTADO_BY_ID: 'Estado',
  PUT_ESTADO_MASIVO: 'Venta/cambioEstadosMasivo',

  POST_ESTADO_MENSAJERIA_INSERT: 'EstadoMensajeria/estadosMensajeria',
  PUT_ESTADO_MENSAJERIA_UPDATE: 'EstadoMensajeria/estadosMensajeria',
  DELETE_ESTADO_MENSAJERIA_BY_ID: 'EstadoMensajeria',
  PUT_ESTADO_MENSAJERIA_MASIVO_UPDATE: 'Venta/cambioEstadosMensajeriaMasivo',

  POST_TRANSMITIR_INPOST: 'Inpost',
  POST_TRANSMITIR_SEUR: 'Seur',
  DELETE_LIMPIAR_DATOS_MENSAJERIA: 'Mensajeria',
  DELETE_LIMPIAR_DATOS_MENSAJERIA_VENTAIDS: 'Mensajeria/deleteMasivo',
  GET_ETIQUETAS_ZPL_VERIFICAR: 'Mensajeria/etiquetas-zpl/verificar',
  POST_ETIQUETAS_ZPL_TXT: 'Mensajeria/etiquetas-zpl/txt',
  POST_ETIQUETAS_ZPL_PDF_LABELARY: 'Mensajeria/etiquetas-zpl/pdf-labelary',
  POST_ETIQUETAS_ZPL_PDF_LOCAL: 'Mensajeria/etiquetas-zpl/pdf-local',

  GET_FILTER_AMAZON: 'Amazon/getAmazonSearch',
  POST_TRANSMITIR_AMAZON: 'Amazon/transmitirAmazon',
  GET_EMPRESA_ENVIO_DEFAULT_AMAZON: 'Amazon/getEmpresaEnvioDefault',

  // Configuracion Portal

  GET_CONSULTA_EMAILS: 'ConsultaEmail/consultaEmails',
  POST_CONSULTA_EMAIL_INSERT: 'ConsultaEmail/consultaEmails',
  PUT_CONSULTA_EMAIL_UPDATE: 'ConsultaEmail/consultaEmails',
  DELETE_CONSULTA_EMAIL_BY_ID: 'ConsultaEmail',

  GET_BANNERS: 'Banner/banners/allBanners',
  GET_BANNERS_DIAS_SEMANA: 'Banner/banners/allBannersDiasSemana',
  GET_BANNER_BY_ID: 'Banner/banners',
  POST_BANNER_INSERT: 'Banner/banners',
  PUT_BANNER_UPDATE: 'Banner/banners',
  DELETE_BANNER_BY_ID: 'Banner',
  PUT_ACTIVAR_BANNER_UPDATE: 'Banner/banners/activarBanner',

  GET_BANNER_SEMANA_BY_IDIOMA_ID: 'BannerConfiguracion/bannerConfiguracionesByIdiomaId',
  PUT_BANNER_SEMANA_UPDATE: 'BannerConfiguracion/bannerConfiguraciones/ActivarBannerSemana',

  GET_CATEGORIA_HOME_ALL: 'CategoriaHome/categoriasHomeByIdiomaId',
  GET_CATEGORIA_HOME_SELECTED: 'CategoriaHome/categoriasHomeSelectedByIdiomaId',
  GET_CATEGORIA_ESPECIAL_SELECTED: 'CategoriaHome/categoriasEspecialesByIdiomaId',
  GET_CATEGORIA_HOME_BY_CATEGORIA_ID: 'CategoriaHome/categoriasHomeByCategoriaId',
  GET_CATEGORIA_HOME_BY_ETIQUETA_ID: 'CategoriaHome/categoriasHomeByEtiquetaId',
  GET_CATEGORIA_HOME_BY_FECHA_ID: 'CategoriaHome/categoriasHomeByFechaId',
  POST_CATEGORIA_HOME_INSERT: 'CategoriaHome/categoriasHome',
  PUT_CATEGORIA_HOME_UPDATE: 'CategoriaHome/categoriasHome',
  DELETE_CATEGORIA_HOME_BY_ID: 'CategoriaHome',
  PUT_CATEGORIA_HOME_SELECTED_UPDATE: 'CategoriaHome/categoriasHome/updatePosiciones',
  PUT_CATEGORIA_ESPECIAL_SELECTED_UPDATE: 'CategoriaHome/categoriasEspeciales/updatePosiciones',

  GET_PRODUCTOS_SEMANA_HOME_SELECTED: 'ProductoSemanaHome/productosSemanaHomeSelectedByIdiomaId',
  PUT_PRODUCTOS_SEMANA_HOME_SELECTED_UPDATE:
    'ProductoSemanaHome/productosSemanaHome/updatePosiciones',

  GET_TRADUCCIONES_PAGINA: 'TraduccionPagina/traduccionPaginasUrl',
  POST_TRADUCCION_PAGINA_INSERT: 'TraduccionPagina/traduccionPaginas',
  PUT_TRADUCCION_PAGINA_UPDATE: 'TraduccionPagina/traduccionPaginas',
  DELETE_TRADUCCION_PAGINA_BY_ID: 'TraduccionPagina',
  GET_TRADUCCION_PAGINA_BY_TIPO_ID: 'TraduccionPagina/traduccionPaginasByTipo',

  GET_MENUS: 'Menu/menusChildren',
  GET_MENUS_PARENTS: 'Menu/menusParent',
  POST_MENU_INSERT: 'Menu/menus',
  PUT_MENU_UPDATE: 'Menu/menus',
  DELETE_MENU_BY_ID: 'Menu',
  GET_MENU_BY_ID: 'Menu/menus',

  // Template
  GET_MAIL_TEMPLATE_BY_ID: 'MailTemplate/mailsTemplate',
  GET_MAIL_TEMPLATE_BY_GROUP: 'MailTemplate/mailsTemplate/getGroup',
  PUT_MAIL_TEMPLATE_UPDATE: 'MailTemplate/mailsTemplate',
  DELETE_MAIL_TEMPLATE_BY_ID: 'MailTemplate',

  // Reportes

  ETIQUETA_COMIDA: 'EtiquetaComida/EtiquetaComida',

  // Ventas
  GET_VENTAS: 'Venta/ventas',
  GET_VENTAS_LIST_ADMIN_BY_IDS: 'Venta/ventasListAdmin',
  POST_TRASPASAR_VENTA: 'Venta/traspasarItemsVenta',
  PUT_VENTA_UPDATE: 'Venta/modificarDatosVentaFromAdmin',
  POST_CREAR_NUEVO_PEDIDO_ADMIN: 'Venta/crearNuevoPedidoAdmin',
  PUT_CAMBIAR_HORARIO_MRW_MASIVO_AGREGADOR: 'Venta/cambioHorarioMrwMasivo',
  PUT_BORRAR_MENSAJERO_UPDATE: 'Venta/setVentaTruck',
  PUT_BORRAR_BANDEJA_UPDATE: 'Venta/quitarBandeja',
  PUT_MARCAR_PAGADO_UPDATE: 'Venta/marcarPagado',
  PUT_ASIGNAR_NUMERO_FACTURA: 'Venta/asignarNumeroFactura',
  POST_INSERTAR_DEVOLUCION_INSERT: 'Venta/insertarDevolucion',
  POST_INSERTAR_NUEVO_ABONO_INSERT: 'Venta/insertarAbono',
  PUT_ANULAR_DEVOLUCION_UPDATE: 'Venta/anularDevolucion',
  GET_VENTA_DEVOLUCIONES_AGG: 'Venta/getVentaDevolucion',
  POST_VENTA_CONFIRMAR_DEVOLUCIONES_AGG: 'Venta/insertarConfirmacionDevolucion',
  PUT_SET_VENTA_LETRA_UPDATE: 'Venta/setVentaLetra',
  PUT_VENTA_ACTUALIZAR_FORMA_PAGO_UPDATE: 'Venta/actualizarFormaPago',
  PUT_SET_VENTA_VIP_UPDATE: 'Venta/setVentaVip',
  PUT_CAMBIAR_ENVIO_SEUR: 'Venta/cambiarEnvioSeur',
  GET_VENTA_BY_ID: 'Venta',
  GET_VENTA_RECOGIDA_BY_ID: 'Venta/recogidaVenta',
  PUT_SET_VENTA_RECOGIDA: 'Venta/setVentaRecogida',
  GET_VENTA_CONTROLDISENO_BY_ID: 'Venta/ventaControlDiseno',
  GET_VENTAITEMS_CARRITO_ADMIN_BY_VENTA_ID: 'Venta/ventaItemsCarritoAdmin',
  PUT_CANCELAR_VENTA_UPDATE: 'Venta/cancelarVenta',
  PUT_MODIFICAR_ESTADOS_MENSAJERIA_UPDATE: 'Venta/modificarEstadoMensajeria',
  GET_VENTAS_LIST: 'Venta/ventasList',
  GET_VENTAS_FILTER_LIST: 'Venta/ventasListFilter',
  GET_VENTAS_FILTER_REVIEW_LIST: 'Venta/ventasListFilterReview',
  GET_VENTAS_FILTER_LADRON_LIST: 'Venta/ventasListFilterLadron',
  GET_VENTAS_FILTER_MENSAJEROS_NUESTROS_LIST: 'Venta/ventasListFilterMensajerosNuestros',
  GET_VENTAS_FILTER_GRABADOS_SIN_PERSO_LIST: 'Venta/ventasListFilterGrabadosSinPerso',
  GET_VENTAS_FILTER_BORDADOS_SIN_PERSO_LIST: 'Venta/ventasListFilterBordadosSinPerso',
  GET_VENTAS_FILTER_RESCATE_LIST: 'Venta/ventasListFilterRescate',
  GET_VENTAS_FILTER_PERSONALIZADOS_LIST: 'Venta/ventasListFilterPersonalizados',
  GET_VENTAS_FILTER_PERSONALIZADOS_TOTAL_LIST: 'Venta/ventasListFilterPersonalizadosTotal',
  GET_VENTAS_FILTER_PERSONALIZADOS_PREPARADOS_LIST:
    'Venta/ventasListFilterPersonalizadosPreparados',
  GET_VENTAS_FILTER_PERSONALIZADOS_FABRICADOS_LIST:
    'Venta/ventasListFilterPersonalizadosFabricados',
  GET_VENTAS_FILTER_EN_SOBRE_LIST: 'Venta/ventasListFilterEnSobre',
  GET_VENTAS_FILTER_AMAZON_LIST: 'Venta/ventasListFilterAmazon',
  GET_VENTAS_FILTER_TODOS_LIST: 'Venta/ventasListFilterTodos',
  GET_VENTAS_FILTER_NOCTURNOS_LIST: 'Venta/ventasListFilterNocturnos',
  GET_VENTAS_FILTER_DIURNOS_LIST: 'Venta/ventasListFilterDiurnos',
  GET_VENTAS_FILTER_FIGURAS_LEGO_LIST: 'Venta/ventasListFilterFigurasLego',
  GET_VENTAS_FILTER_ECOMMERCE_LIST: 'Venta/ventasListFilterEcommerce',
  GET_VENTAS_FILTER_ECOMMERCE_TRAMO_HORARIO_LIST: 'Venta/ventasListFilterEcommerceTramoHorario',
  GET_VENTAS_FILTER_LOCAL_LIST: 'Venta/ventasListFilterLocal',
  GET_VENTAS_FILTER_DIGITAL_LIST: 'Venta/ventasListFilterDigital',
  GET_VENTAS_FILTER_EMPLEADOS_LIST: 'Venta/ventasListFilterEmpleados',
  GET_VENTAS_FILTER_CANTIDAD_PERSONALIZADOS_LIST: 'Venta/ventasListFilterCantidadPersonalizados',
  GET_VENTAS_FILTER_EKOMI_LIST: 'Venta/ventasListFilterEkomi',
  GET_VENTAS_FILTER_FUERA_DE_ESPANA_LIST: 'Venta/ventasListFilterFueraDeEspana',
  GET_VENTAS_FILTER_FUERA_DE_ESPANA_SEUR_LIST: 'Venta/ventasListFilterFueraDeEspanaSeur',
  GET_VENTAS_FILTER_FUERA_DE_ESPANA_DHL_LIST: 'Venta/ventasListFilterFueraDeEspanaDhl',
  GET_VENTAS_FILTER_DHL_LIST: 'Venta/ventasListFilterDhl',
  GET_VENTAS_FILTER_CHOCOMENSAJE_MASIVO_LIST: 'Venta/ventasListFilterChocomensajeMasivo',
  GET_VENTAS_FILTER_NOCTURNOS_CORREOS_LIST: 'Venta/ventasListFilterNocturnosCorreos',
  GET_VENTAS_FILTER_NUESTROS_NOCTURNO_LIST: 'Venta/ventasListFilterNuestrosNocturno',
  GET_VENTAS_TILDAR_FILTER_LIST: 'Venta/ventasTildarFilter',
  GET_OBSERVACIONES_VENTAS_LIST: 'Observacion/observaciones',
  GET_MAIL_OBSERVACIONES_TEMPLATE_VENTAS_LIST: 'MailObservacionTemplate/mailObservacionesTemplates',
  SET_VENTAITEM_FALTANTE: 'Venta/setVentaItemFaltante',
  SET_OBSERVACIONES_BULTO: 'Venta/setObservacionesBulto',
  SET_BULTOS_CHECK: 'Venta/setBultosCheck',
  SET_VENTAITEM_PERSONALIZADO: 'Venta/addLogVentaItemPersonalizado',
  SET_VENTAITEM_SEPARADO: 'Venta/addLogVentaItemSeparado',
  SET_VENTAITEM_VERIFICADO: 'Venta/addLogVentaItemVerificado',
  SET_VENTA_ITEMS_PREPARADOS: 'Venta/setVentaItemsPreparados',
  SET_VENTAITEM_IMPRIMIR: 'Venta/setVentaItemImprimir',
  DELETE_VENTAITEM_BY_ID: 'Venta/deleteVentaItemFromAdmin',
  GET_ESTANTERIA_VENTA: 'Venta/getEstanteVentaId',
  GET_CANTIDAD_PEDIDOS_POR_HORARIO: 'Venta/getCantidadPedidosPorHorario',
  GET_COUNT_VENTAS_BY_FECHA_ENTREGA_HORARIO: 'Venta/getCountVentasByFechaEntregaHorario',
  GET_COUNT_VENTAS_BY_FECHA_MADRID: 'Venta/getCountVentasByFechaMadrid',
  SET_VENTA_BANDEJA: 'Venta/setVentaBandeja',
  SET_VENTA_BANDEJA_MASIVO: 'Venta/setVentaBandejaMasivo',
  REMOVE_VENTA_ESTANTE: 'Venta/removeVentaEstante',
  SET_VENTA_FINALIZAR_IMPRIMIR: 'Venta/setFinalizarImprimir',
  SET_VENTA_FINALIZAR_IMPRIMIR_MASIVO: 'Venta/setFinalizarImprimirMasivo',
  SET_VENTA_ESTANTERIA: 'Venta/setEstante',
  SET_OBSERVACIONES_CIERRE: 'Venta/addObservacionCierre',
  GET_VENTAS_AGRUPADAS_LIST: 'Venta/ventasAgrupadas',
  GET_MODIFICACIONES_VENTA_LIST: 'Venta/getModificacionesVenta',
  GET_HISTORICO_NOCTURNO_LIST: 'Venta/getHistoricoNocturno',
  GET_HISTORICO_NOCTURNO_RANGO_LIST: 'Venta/getHistoricoNocturnoRango',
  CREATE_SNAPSHOT: 'Venta/createListFilterSnapshot',
  CREATE_SNAPSHOT_DHL: 'Venta/createListFilterSnapshotDHL',
  CREATE_SNAPSHOT_FUERA_ESPANA: 'Venta/createListFilterSnapshotFueraEspana',
  CREATE_SNAPSHOT_COMBINADO: 'Venta/createListFilterSnapshotCombinado',
  CREATE_SNAPSHOT_MENSAJEROS_NUESTROS: 'Venta/createListFilterSnapshotMensajerosNuestros',
  GET_VELOCIDAD_ULTIMA_HORA: 'Venta/getVelocidadUltimaHora',
  SET_ESTADO_VENTA: 'Venta/modificarEstado',
  SET_ESTADO_BULTO_VENTA: 'Venta/modificarEstadoBultoVenta',
  GET_ID_BY_ALBARAN: 'Venta/getIdByAlbaran',
  SET_VENTA_VISTO_EN_CUENTA: 'Venta/setVistoEnCuenta',
  SET_VENTA_INPOST_PUP_ID: 'Venta/setInPostPupId',
  SET_RECUPERAR_PEDIDO: 'Venta/setRecuperarPedido',
  PUT_TILDA_LISTO_PARA_IMPRIMIR_VENTA: 'Venta/tildaListoImprimir',
  PUT_TILDA_LISTO_PARA_IMPRIMIR_MASIVO_VENTA: 'Venta/tildaListoImprimirMasivo',
  PUT_ADD_ITEM_VENTA: 'Venta/addItemVenta',
  PUT_REPETIR_PEDIDO_VENTA: 'Venta/repetirPedido',
  DELETE_TRANSPORTISTA_VENTA: 'Venta/eliminarTransportistasVenta',
  SET_DIRECCION_MAPA_VENTA: 'Venta/setDireccionMapa',
  GET_PEDIDOS_MENSAJERO_VENTA: 'Venta/getPedidosMensajeros',
  SET_VENTA_ITEM_QUANTITY: 'Venta/updateQuantityVentaItem',
  SET_VENTA_ITEMS_PRECIO: 'Venta/updatePrecioVentaItems',
  GET_VENTA_COMPARACION_ANIO_ANTERIOR: 'Venta/GetVentasCompracionAnioAnterior',
  GET_VENTA_LISTADO_FALTANTES: 'Venta/GetListadoVentasFaltantes',
  GET_VENTA_LISTADO_RAMOS_VENDIDOS_AGREGADOR: 'Venta/getRamosVendidos',
  GET_VENTA_LISTADO_PRODUCTOS_VENDIDOS_AGREGADOR: 'Venta/getProductosVendidos',
  GET_VENTA_LISTADO_PRODUCTOS_VENDIDOS_URL_AGREGADOR: 'Venta/getProductosVendidosUrl',
  GET_VENTA_LISTADO_PRODUCTOS_FABRICADOS_AGREGADOR: 'Venta/getVentaProductosFabricados',
  GET_VENTA_MENSAJERIA: 'Venta/mensajeria',
  GET_VENTA_FACTURASII_CONSULTA: 'Venta/getVentaSIIConsulta',
  GET_VENTA_FACTURASII_EXCEL: 'Venta/getVentaSIIFicheroExcel',
  GET_VENTA_FACTURASII_EXCEL_AGRUPADOS: 'Venta/getVentaSIIFicheroExcelAgrupados',
  GET_VENTA_FACTURASII_EXCEL_AGRUPADOS_INTER: 'Venta/getVentaSIIFicheroExcelInterAgrupados',
  POST_VENTA_FACTURASII_MARCAR_ENVIADA_EXCEL: 'Venta/setVentaSIIMarcarEnviadasExcel',

  POST_PROCESAR_FICHERO_PEDIDO_MASIVO_AGREGADOR: 'Venta/procesarFicheroVentaMasiva',
  PUT_ACTUALIZAR_LINEA_PEDIDO_MASIVO_AGREGADOR: 'Venta/updateVentaMasivaData',
  POST_CREAR_PEDIDO_MASIVO_AGREGADOR: 'Venta/insertarVentaMasiva',
  GET_VENTA_PEDIDO_MASIVO_EXCEL_FILE: 'Venta/getVentaPedidoMasivoExcelFile',

  SET_CANCELAR_VENTAS: 'Venta/setCancelarPedidos',
  SET_REPETIDOS_CONFIRMADOS_VENTAS: 'Venta/setEstablecerRepetidosConfirmado',

  // Estantes Incompleotos
  GET_VENTA_ESTANTES_INCOMPLETOS_AGREGADOR: 'Venta/getEstantesIncompletos',

  GET_LADRONES: 'Ladron/ladrones',
  PUT_LADRON_UPDATE: 'Ladron/modificarLadron',
  POST_LADRON_INSERT: 'Ladron/insertarLadron',
  DELETE_LADRON_BY_ID: 'Ladron',
  SET_ORDEN_MENSAJERO_VENTAS: 'Venta/setOrdenMensajeroVentas',
  SET_DATOS_ENTREGA_VENTA: 'Venta/setDatosEntregaVenta',
  SET_TRANSPORTISTA_VENTA: 'Venta/setTransportistaVenta',

  DELETE_ABONO_BY_ID: 'Abono',
  GET_ABONOS_LIST: 'Abono/abonosList',

  DELETE_CUPON: 'Cupon/setCuponUsado',
  GET_CUPONES_NO_USADOS_LIST: 'Cupon/cuponesNoUsados',
  ADD_CUPONES: 'Cupon/setCuponesUsados',

  GET_CODIGO_BARRAS_ESTANTERIA: 'BarCode/barcodesEstanteria',

  POST_DHL_BUSCAR: 'Dhl/buscar',
  POST_DHL_DHL_BUSCAR: 'Dhl/dhl',
  POST_DHL_GUARDAR: 'Dhl/guardarDhls',
  POST_DHL_TRANSMITIR: 'Dhl/transmitirDhl',

  POST_MRWCLICK_BUSCAR: 'MrwClick/buscar',
  POST_MRWCLICK_DIURNOS: 'MrwClick/diurnos',
  POST_MRWCLICK_NOCTURNOS: 'MrwClick/nocturnos',
  POST_MRWCLICK_ECOMMERCE: 'MrwClick/ecommerce',
  POST_MRWCLICK_ECOMMERCE_TH: 'MrwClick/ecommerceTh',
  POST_MRWCLICK_SOBRES: 'MrwClick/sobres',
  POST_MRWCLICK_GUARDAR: 'MrwClick/guardarMrws',
  POST_MRWCLCIK_TRANSMITIR: 'MrwClick/transmitirMrwClick',

  POST_NACEX_BUSCAR: 'Nacex/buscar',
  POST_NACEX_GUARDAR: 'Nacex/guardarNacex',
  POST_NACEX_TRANSMITIR: 'Nacex/transmitirNacex',

  POST_SEUR_BUSCAR: 'Seur/buscar',
  POST_SEUR_SEUR_BUSCAR: 'Seur/seur',
  POST_SEUR_GUARDAR: 'Seur/guardarSeurs',
  POST_SEURS_TRANSMITIR: 'Seur/transmitirSeur',

  POST_CORREOS_EXPRESS_BUSCAR: 'CorreosExpress/buscar',
  POST_CORREOS_EXPRESS_ECOMMERCE: 'CorreosExpress/ecommerce',
  POST_CORREOS_EXPRESS_ECOMMERCE_TRAMO: 'CorreosExpress/ecommerceTramo',
  POST_CORREOS_EXPRESS_SOBRES: 'CorreosExpress/sobres',
  POST_CORREOS_EXPRESS_TRANSMITIR: 'CorreosExpress/transmitirCorreosExpress',

  GET_CORREOS_EXPRESS: 'CorreosExpress',

  GET_MRW_RECLAMACIONES: 'MrwReclamacion',
  PATCH_MRW_RECLAMACIONES: 'MrwReclamacion',
  GET_MRW_RECLAMACIONES_VENTAS: 'Venta/getReclamacionesMrwVenta',
  POST_MRW_RECLAMACIONES: 'MrwReclamaciones/procesarReclamaciones',
  POST_MRW_RECLAMACION_MANUAL: 'MrwReclamacion/MrwReclamacionManual',

  POST_CORREOS_EXPRESS_GUARDAR: 'CorreosExpress/guardarCorreosExpress',

  POST_OBSERVACION_SEGUIMIENTO_VENTA_INSERT: 'Venta/insertarObservacionSeguimiento',

  POST_OBSERVACION_INSERT: 'Observacion/insertarObservaciones',
  POST_OBSERVACION_UPDATE: 'Observacion/modificarObservacion',
  DELETE_OBSERVACION: 'Observacion',

  POST_ESTADO_BULTO_INSERT: 'EstadoBulto/insertarEstadoBulto',
  POST_ESTADO_BULTO_UPDATE: 'EstadoBulto/modificarEstadoBulto',
  DELETE_ESTADO_BULTO: 'EstadoBulto',
  GET_ESTADOS_BULTOS: 'EstadoBulto/estadosBultos',

  GET_BANDEJAS_TODAS: 'Bandeja/bandejasTodas',
  PUT_ESTADO_BULTO_UPDATE: 'Bandeja/setBandejaDatos',
  GET_BANDEJAS: 'Bandeja/bandejas',
  GET_BANDEJAS_LOG: 'Bandeja/bandejasLog',
  PUT_TERMINAR_BANDEJA: 'Bandeja/terminarBandeja',
  SET_BANDEJA_BLOQUEADA: 'Bandeja/setBandejaBloqueada',
  SET_BANDEJA_PROPUESTA: 'Bandeja/setBandejaPropuesta',

  GET_ESTANTERIAS: 'Estanteria',
  POST_ESTANTERIAS_UPDATE: 'Estanteria/modificarEstanteria',
  DELETE_ESTANTERIA: 'Estanteria',
  GET_ESTANTES_LLENOS: 'Estanteria/estantesLlenos',
  ORDEN_ESTANTERIA: 'Estanteria/ordenEstanteria',
  GET_ESTANTE_ALEATORIO: 'Estanteria/estanteAleatorio',
  GET_ESTANTE_EN_USO: 'Estanteria/estanteEnUso',

  POST_OBSERVACION_PREPARACION_VENTA_INSERT: 'Venta/insertarObservacionPreparacion',

  POST_ENVIAR_MAIL_OBSERVACION_VENTA: 'MailObservacionVenta/enviarMailObservacionVenta',
  POST_ENVIAR_MAIL_VENTA: 'MailVenta/enviarMailVenta',
  POST_OBTENER_PREVIEW_MAIL_VENTA: 'MailVenta/obtenerPreviewMailVenta',

  GET_ID_DESENCRIPTADO: 'Venta/getIdDesencriptado',

  SEND_WHATSAPP_VENTA: 'WhatsappVenta',
  PATCH_SET_PREFIJO_WHATSAPP: 'Venta/setPrefijoWhatsappVenta',

  SEND_EMAILS_RESENA_VENTA: 'MailResenaVenta',

  SET_MENSAJERO_SEPARADO: 'Venta/setMensajeroSeparado',

  // Marketing
  GET_DESCUENTOS: 'Descuento/descuentos',
  GET_DESCUENTOS_FILTERED: 'Descuento/descuentos/filtered',
  PUT_DESCUENTO_UPDATE: 'Descuento/setDescuentoUsado',
  DELETE_DESCUENTO_BY_ID: 'Descuento',
  GET_DESCUENTO_BY_ID_INCLUDE_DESCUENTOS: 'Descuento/descuentoByIdIncludeDescuentos',
  UPDATE_DESCUENTO: 'Descuento/descuentos',
  INSERT_DESCUENTO: 'Descuento/descuentos',

  // Marketing Imagen Descuentos
  GET_IMAGENDESCUENTO_WITH_IMAGE: 'ImagenDescuento/getImagenDescuentoWithImage',
  INSERT_IMAGENDESCUENTO: 'ImagenDescuento/imagenDescuento',

  // Bibliotecas Prediseño SVG
  GET_BIBPREDSVG: 'BibliotecaPredSvg/bibliotecasPredSvg',
  GET_ENUMS: 'BibliotecaPredSvg/enums',
  GET_BIBPREDSVG_BY_ID: 'BibliotecaPredSvg/bibliotecasPredSvg',
  GET_BIBPREDSVG_BY_BIBPLANTILLA_ID: 'BibliotecaPredSvg/getByBibPlantillaId',
  GET_BIBPREDSVG_BY_PRODUCTO_ID: 'BibliotecaPredSvg/getByProductoId',
  GET_BIBPREDSVG_PRODUCTOS_BY_PLANTILLA_ID: 'BibliotecaPredSvg/getBibPredProductosByPlantillaId',
  GET_BIBPREDSVG_FILTERED: 'BibliotecaPredSvg/bibliotecasPredSvg/filtered',
  DELETE_BIBPREDSVG_BY_ID: 'BibliotecaPredSvg',
  UPDATE_BIBPREDSVG: 'BibliotecaPredSvg/bibliotecasPredSvg',
  UPDATE_BIBSPREDSVG_PRODUCTO: 'BibliotecaPredSvg/bibliotecasPredSvgProducto',
  INSERT_BIBPREDSVG: 'BibliotecaPredSvg/bibliotecasPredSvg',

  GET_TIPOS_SVG: 'TipoDisenoSvg/tipoDiseno',
  INSERT_TIPO_SVG: 'TipoDisenoSvg/tipoDiseno',

  GET_SUBTIPOS_SVG: 'SubtipoDiseno/subtipoDiseno',
  GET_SUBTIPOS_SVG_BY_PLANTILLA_ID: 'SubtipoDiseno/subtipoDiseno/filteredByPlantilla',
  INSERT_SUBTIPO_SVG: 'SubtipoDiseno/subtipoDiseno',

  GET_FONTS: 'Font/font',
  GET_FONTS_FILTERED: 'Font/font/filtered',
  GET_FONTS_FILE: 'Font/getFontsFile',
  GET_SVG_FILE: 'BibliotecaPredSvg/getSvgFile',
  GET_FONT_FILE: 'Font',
  GET_FONT_BY_ID: 'Font',
  DELETE_FONT_BY_ID: 'Font',
  POST_FONT_INSERT: 'Font',
  PUT_FONT_UPDATE: 'Font',
  PUT_FONT_ORDER_UPDATE: 'Font/updateOrder',
  GENERATE_FONTS: 'Font/createFileFonts',

  // Bibliotecas de Plantillas
  GET_BIBPLANTILLA_FILTERED: 'BibliotecaPlantilla/bibliotecasPlantilla/filtered',
  GET_BIBPLANTILLA_WITH_FILES_FILTERED:
    'BibliotecaPlantilla/bibliotecasPlantilla/filteredWithFiles',
  DELETE_BIBPLANTILLA_BY_ID: 'BibliotecaPlantilla',
  GET_PLANTILLA_FILE: 'BibliotecaPlantilla/getPlantillaFile',
  GET_BIBPLANTILLA_BY_PRODUCTO_ID: 'BibliotecaPlantilla/getByProductoId',
  UPDATE_BIBPLANTILLA: 'BibliotecaPlantilla/bibliotecasPlantilla',
  UPDATE_BIBSPLANTILLA_PRODUCTO: 'BibliotecaPlantilla/bibliotecasPlantillaProducto',
  INSERT_BIBPLANTILLA: 'BibliotecaPlantilla/bibliotecasPlantilla',
  GET_BIBPLANTILLA_BY_ID: 'BibliotecaPlantilla/bibliotecasPlantilla',

  // Combos Svg
  GET_COMBOSVG_FILTERED: 'ComboSvg/combosSvg/filtered',
  DELETE_COMBOSVG_BY_ID: 'ComboSvg',
  UPDATE_COMBOSVG: 'ComboSvg/combosSvg',
  INSERT_COMBOSVG: 'ComboSvg/combosSvg',
  GET_COMBOSVG_BY_ID: 'ComboSvg/combosSvg',
  GET_COMBOS_SVG_BY_PRODUCTO_ID: 'ComboSvg/getByProductoId',
  GET_COMBOS_SVG_BY_PLANTILLA_ID: 'ComboSvg/getByPlantillaId',
  GET_COMBOSVG_PRODUCTO_BY_PRODUCTO_ID_COMBO_ID: 'ComboSvg/comboSvgProducto',
  UPDATE_COMBOS_SVG_PRODUCTO: 'ComboSvg/combosSvgProducto',
  UPDATE_COMBO_SVG_PRODUCTO: 'ComboSvg/combosSvgProducto',

  // Personalización Svg
  GET_DISENO_SVG_PREVIEW: 'PersonalizacionSvg/getDisenoSvgPreview',
  GET_DISENO_SVG_BY_ID: 'PersonalizacionSvg/getDisenoClienteSvgById',
  GET_DATOS_IMPRESION_DISENO_SVG_BY_ID: 'PersonalizacionSvg/getDatosImpresionDisenoSvg',
  GENERAR_DISENO_FINAL_SVG: 'PersonalizacionSvg/generarDisenoFinalSvg',
  GET_DISENO_SVG_IMAGEN_FINAL: 'PersonalizacionSvg/getDisenoImagenFinal',
  GET_DISENOS_SVG_IMAGEN_FINAL_ZIP: 'PersonalizacionSvg/getDisenosImagenFinalZip',
  ADD_ETIQUETA_DISENO: 'PersonalizacionSvg/AddEtiquetaToDiseno',
  GUARDAR_DISENO_PEGATINA: 'PersonalizacionSvg/GuardarDisenoFinalPegatina',
  ELIMINAR_IMAGEN_DISENO_FINAL: 'PersonalizacionSvg/deleteDisenoImagenFinal',
  GET_ILUSTRACION_IMAGEN: 'PersonalizacionIlustracion/getImagenIlustracion',
  INSERT_ILUSTRACION_IMAGEN: 'PersonalizacionIlustracion/guardarIlustracionVenta',
  DELETE_ILUSTRACION_IMAGEN: 'PersonalizacionIlustracion/eliminarIlustracion',

  // Comerciantes
  GET_DISTRIBUIDORES: 'Distribuidor/distribuidores',

  // Imágenes Incidencias
  INSERT_IMAGEN_INCIDENCIA: 'ImagenIncidencia',
  DELETE_IMAGEN_INCIDENCIA: 'ImagenIncidencia/deleteImagenIncidencia',
  GET_IMAGEN_INCIDENCIA_FILE: 'ImagenIncidencia/getImagenIncidenciaFile',

  // SPOTIFY
  GET_SPOTIFY_TOKEN: 'SpotifyCode/token',
  SPOTIFY_SEARCH: 'SpotifyCode/search',
  GET_SPOTIFY_CODE_SVG: 'SpotifyCode/getCodeSvg',
  GET_SPOTIFY_CODE_PNG: 'SpotifyCode/getCodePng',

  // STICKERS
  STICKERS: 'Sticker',
  CATEGORIAS_STICKERS: 'Sticker/categoriaSticker',

  // Diseños Amazon
  GET_IMAGEN_AMAZON: 'PersonalizacionSvg/getImagenAmazon',
  GUARDAR_DISENO_AMAZON: 'PersonalizacionSvg/guardarDisenoSvgAmazon',

  // Observaciones Personalizacion
  INSERT_OBSERVACION_PERSONALIZACION: 'Venta/insertarObservacionPersonalizacion',

  // Bibliotecas de Preguntas
  GET_BIBLIOTECAS_PREGUNTAS: 'BibliotecaPregunta/bibliotecasPregunta',
  GET_BIBLIOTECAS_PREGUNTAS_FILTERED: 'BibliotecaPregunta/filtered',
  DELETE_BIBLIOTECA_PREGUNTA: 'BibliotecaPregunta/deleteBibliotecaPregunta',
  INSERT_BIBLIOTECA_PREGUNTA: 'BibliotecaPregunta/insertBibliotecaPregunta',
  UPDATE_BIBLIOTECA_PREGUNTA: 'BibliotecaPregunta/updateBibliotecaPregunta',
  SET_ESPIJAMA_BIBLIOTECA_PREGUNTA: 'BibliotecaPregunta/bibliotecaPregunta/setEsPijama',
  SET_REPETIR_BY_QUANTITY_BIBLIOTECA_PREGUNTA:
    'BibliotecaPregunta/bibliotecaPregunta/setRepetirByQuantity',
  DUPLICATE_BIBLIOTECA_PREGUNTA: 'BibliotecaPregunta/duplicateBibliotecaPregunta',
  GET_BIBLIOTECA_PREGUNTA_BY_ID: 'BibliotecaPregunta/bibliotecaPregunta',
  INSERT_PREGUNTA_BIBLIOTECA: 'BibliotecaPregunta/insertPreguntaBiblioteca',
  INSERT_OPCION_PREGUNTA: 'BibliotecaPregunta/opcionPregunta',
  UPDATE_OPCION_PREGUNTA: 'BibliotecaPregunta/opcionPregunta',
  GET_BIBLIOTECA_PREGUNTA_BY_PRODUCTO_ID: 'BibliotecaPregunta/getByProductoId',
  UPDATE_BIBPREGUNTAS_PRODUCTO: 'BibliotecaPregunta/bibliotecasPreguntaProducto',

  // Bibliotecas de Familias
  GET_BIBFAMILIA: 'BibliotecaFamilia',
  GET_BIBFAMILIA_BY_ID: 'BibliotecaFamilia',
  UPDATE_BIBFAMILIA: 'BibliotecaFamilia',
  INSERT_BIBFAMILIA: 'BibliotecaFamilia',
  GET_BIBFAMILIA_FILTERED: 'BibliotecaFamilia/filtered',
  DELETE_BIBFAMILIA: 'BibliotecaFamilia',
  GET_PEGATINA_FAMILIA_FILE: 'PegatinaFamilia/getPegatinaFile',
  UPDATE_PEGATINA_FAMILIA: 'PegatinaFamilia',
  INSERT_PEGATINA_FAMILIA: 'PegatinaFamilia',
  INSERT_PEGATINA_FAMILIA_MASIVO: 'PegatinaFamilia/masivo',
  DELETE_PEGATINA_FAMILIA: 'PegatinaFamilia',
  DELETE_PEGATINA_FAMILIA_MASIVO: 'PegatinaFamilia/borradoMasivo',
  GET_PEGATINAS_FAMILIA_IMAGEN_BY_BIBLITECAID: 'PegatinaFamilia/getPegatinasWithImagenByBibliotecaIdAsync',
  UPDATE_PEGATINAS_ORDEN: 'PegatinaFamilia/updateOrdenarPegatinas',
  ETIQUETA_FAMILIA_CONTROLLER: 'EtiquetaFamilia',
  GET_BIBLIOTECA_FAMILIA_BY_PRODUCTO_ID: 'BibliotecaFamilia/getByProductoId',
  UPDATE_BIBFAMILIA_PRODUCTO: 'BibliotecaFamilia/bibliotecasFamiliaProducto',
  // Bibliotecas de Fondos para Familias
  GET_BIBFONDOFAMILIA: 'BibliotecaFondoFamilia',
  GET_BIBFONDOFAMILIA_BY_ID: 'BibliotecaFondoFamilia',
  UPDATE_BIBFONDOFAMILIA: 'BibliotecaFondoFamilia',
  UPDATE_BIBFONDOFAMILIA_AREAS: 'BibliotecaFondoFamilia/areas',
  INSERT_BIBFONDOFAMILIA: 'BibliotecaFondoFamilia',
  GET_BIBFONDOFAMILIA_FILTERED: 'BibliotecaFondoFamilia/filtered',
  DELETE_BIBFONDOFAMILIA: 'BibliotecaFondoFamilia',
  GET_FONDO_FILE: 'BibliotecaFondoFamilia/getFondoFile',
  GET_FONDO_PREVIEW: 'BibliotecaFondoFamilia/getFinalImagePreview',
  INSERT_FONDO_FILE: 'BibliotecaFondoFamilia/fondoFamiliaFile',
  UPDATE_FONDO_FILE: 'BibliotecaFondoFamilia/fondoFamiliaFile',
  DELETE_FONDO_FILE: 'BibliotecaFondoFamilia/fondoFamiliaFile',
  INSERT_FONDO_FAMILIA_MASIVO: 'BibliotecaFondoFamilia/fondoFamiliaFile/masivo',
  // PERSONALIZACION FAMILIA
  GET_PREVIEW_FAMILIA: 'PersonalizacionFamilia/getFamiliaPreview',
  GET_FONT_COLOR_FAMILIA: 'PersonalizacionFamilia/getFontColor',
  // Chocomensaje
  GET_CHOCOMENSAJE_PRODUCTO: 'Chocomensaje',
  INSERT_CHOCOMENSAJE_PRODUCTO: 'Chocomensaje',
  UPDATE_CHOCOMENSAJE_PRODUCTO: 'Chocomensaje',
  DELETE_CHOCOMENSAJE_PRODUCTO: 'Chocomensaje',
  // IMAGEN CLIENTE
  GET_IMAGEN_CLIENTE_PRODUCTO: 'ImagenCliente',
  INSERT_IMAGEN_CLIENTE_PRODUCTO: 'ImagenCliente',
  UPDATE_IMAGEN_CLIENTE_PRODUCTO: 'ImagenCliente',
  DELETE_IMAGEN_CLIENTE_PRODUCTO: 'ImagenCliente',
  GET_IMAGEN_CLIENTE_PREVIEW: 'PersonalizacionImagenCliente/getPreview',
  GENERAR_IMAGEN_CLIENTE_FINAL: 'PersonalizacionImagenCliente/generarImagenFinal',

  // AUDIO
  GET_AUDIO_PRODUCTO: 'AudioProducto',
  INSERT_AUDIO_PRODUCTO: 'AudioProducto',
  UPDATE_AUDIO_PRODUCTO: 'AudioProducto',
  DELETE_AUDIO_PRODUCTO: 'AudioProducto',

  // LEGO PROPS
  LEGO_PROPS_CONTROLLER: 'LegoProps',

  // COLORES LEGO
  COLOR_LEGO_CONTROLLER: 'ColorLego',
  COLOR_LEGO_RANGE: 'ColorLego/range',

  // Personalizacion Lego
  PERSONALIZACION_LEGO_CONTROLLER: 'PersonalizacionLego',
  PERSONALIZACION_LEGO_RANGE_CONTROLLER: 'PersonalizacionLego/range',

  // Personalización Cliente
  GET_PERSONALIZACION_PRODUCTO: 'PersonalizacionCliente/getPersonalizacionProducto',

  // Personalización obtener reporte piezas
  GET_REPORTE_PIEZAS: 'PersonalizacionCliente/getReportePiezas',

  // Personalización Audio
  GET_DISENO_CLIENTE_AUDIO_FILES: 'PersonalizacionAudio/files',

  // Opciones de spotify
  GET_OPCIONES_SPOTIFY_BY_PRODUCTID: 'OpcionesSpotifyProducto/getByProductoId',
  INSERT_OPCIONES_SPOTIFY: 'OpcionesSpotifyProducto',
  UPDATE_OPCIONES_SPOTIFY: 'OpcionesSpotifyProducto',
  DELETE_OPCIONES_SPOTIFY: 'OpcionesSpotifyProducto',

  // Usuario
  GET_DEPARTAMENTOS: 'Departamento/departamentos',
  GET_DEPARTAMENTO_BY_ID: 'Departamento/departamentos',
  PUT_DEPARTAMENTO_UPDATE: 'Departamento/departamentos',
  POST_DEPARTAMENTO_INSERT: 'Departamento/departamentos',
  DELETE_DEPARTAMENTO_BY_ID: 'Departamento/departamentos',

  GET_USUARIOS_TREE: 'Usuario/UsuariosTree',
  GET_USUARIOS_TREE_FILTERED: 'Usuario/UsuariosTree/filtered',
  GET_USUARIOS: 'Usuario/Usuarios',
  GET_USUARIO_BY_ID: 'Usuario/Usuarios',
  PUT_USUARIO_UPDATE: 'Usuario/Usuarios',
  POST_USUARIO_INSERT: 'Usuario/Usuarios',
  PATCH_USUARIO_UPDATE: 'Usuario/Usuarios',
  DELETE_USUARIO_BY_ID: 'Usuario',
  PATCH_CAMBIAR_PASS_USUARIO: 'Usuario/usuarios/cambiarpass',
  PATCH_CAMBIAR_IMAGEN_USUARIO: 'Usuario/usuarios/setImagen',
  GET_USUARIO_PERFIL_BY_ID: 'Usuario/usuarios/perfil',
  GET_USUARIO_STOCK_MANAGER: 'Usuario/usuarios/perfil/stockmanager',

  // REPORTE
  GET_REPORTE_IMPRIMIR_PMT: 'ImprimirPmt',
  GET_REPORTE_IMPRIMIR_PMT_MASIVO: 'ImprimirPmt/masivo',
  GET_REPORTE_FACTURA_ABONO: 'FacturaAbono',
  GET_REPORTE_FACTURA: 'Factura',
  GET_REPORTE_FACTURA_PROFORMA: 'Factura/proforma',

  GET_LOTES_IMPRESION: 'LoteImpresion',
  GET_LOTES_IMPRESION_FILTERED: 'LoteImpresion/filtered',

  GET_VENTA_USUARIOS: 'Venta/usuariosVentaPreparados',
  GET_USUARIOS_VENTA_BANDEJAS: 'Venta/usuariosVentaBandejas',
  GET_USUARIOS_PRODUCTOS_PREPARADOS: 'Venta/usuariosProductosPreparados',
  GET_USUARIOS_REGISTROS_PEDIDOS: 'Venta/usuariosRegistrosPedidos',

  SET_VENTA_NO_TILDE: 'Venta/setNoTilde',
  SET_BULTO_CHECK: 'Venta/setBultoCheck',

  GET_BIBPRECIOS_BY_ID: 'BibliotecaPrecio',
  GET_BIBPRECIOS_FILTERED: 'BibliotecaPrecio/filtered',
  GET_BIBPRECIOS_URL_EXCEL_FILE: 'BibliotecaPrecio/getexcelfileurl',
  DELETE_BIBPRECIOS_BY_ID: 'BibliotecaPrecio',
  INSERT_BIBPRECIOS: 'BibliotecaPrecio',
  UPDATE_BIBPRECIOS: 'BibliotecaPrecio',

  GET_PRODUCTOS_DESAYUNO: 'Producto/productosDesayuno',
  GET_CATEGORIAS_PRODUCTOS_DESAYUNO: 'Categoria/categoriasProductoDesayuno',
  UPDATE_PRODUCTOS_DESAYUNO: 'Producto/productosDesayuno',

  // Biblioteca de Avatares
  GET_BIBAVATARES: 'BibliotecaAvatares',
  GET_BIBAVATARES_SECCION: 'BibliotecaAvataresSeccion',
  PUT_BIBAVATARES_SECCION_ORDER_UPDATE: 'BibliotecaAvataresSeccion/updateOrder',
  GET_BIBAVATARES_MODELO: 'BibliotecaAvataresModelo',
  GET_BIBAVATARES_PALETA: 'BibliotecaAvataresPaleta',
  GET_BIBAVATARES_SIZE: 'BibliotecaAvataresSize',
  GET_BIBAVATARES_SIZE_FAM: 'BibliotecaAvataresSize/GetAvataresSizesFam',
  GET_BIBAVATARES_LAYER: 'BibliotecaAvataresLayer',
  GET_BIBAVATARES_COLOR: 'BibliotecaAvataresColor',
  GET_BIBAVATARES_CLIENTE_RESUME: 'GetBibliotecaAvatarResume',
  GET_BIBAVATARES_CLIENTE_ADMIN: 'GetBibliotecaAvatarFilter',
  GET_BIBAVATARES_CLIENTE_EMAIL_ADMIN: 'GetBibliotecaAvatarEmail',
  GET_BIBAVATARES_GALERIA: 'BibliotecaAvataresGaleria',
  GET_BIBAVATARES_OBJETO: 'BibliotecaAvataresObjeto',
  GET_BIBAVATARES_OBJETO_UNICO: 'BibliotecaAvataresObjetoUnico',
  GET_BIBAVATARES_OBJETO_VARIANTE: 'BibliotecaAvataresObjetoVariante',
  GET_BIBAVATARES_CUSTOM_PLANTILLA: 'BibliotecaAvataresCustomPlantilla',
  GET_BIBAVATARES_CUSTOM_OBJETO: 'BibliotecaAvataresCustomObjeto',
  GET_BIBAVATARES_PRODUCTO: 'BibliotecaAvataresProducto',
  GET_BIBAVATARES_PIEZA: 'BibliotecaAvataresPieza',
  POST_BIBAVATARES_DUPLICAR: 'BibliotecaAvatares/duplicar',
  POST_BIBAVATARES_GALERIA_ACTIVAR: 'BibliotecaAvataresGaleria/activarObjetosLista',
  POST_BIBAVATARES_GALERIA_ELIMINAR: 'BibliotecaAvataresGaleria/eliminarObjetosLista',
  POST_BIBAVATARES_GALERIA_ORDEN: 'BibliotecaAvataresGaleria/ordenObjetosLista',
  SET_CACHE_AVATARES: 'Avatar',

  // Payments
  GET_STRIPE_PAYMENT_INTENT: 'PagoStripe/GetStripePaymentIntent',
  GET_CONFIG_URL_STRIPE_PAYMENT: 'PagoConfig/GetUrlStripePayment',
  GET_PAGO_ADYEN: 'PagoAdyen/payment',
  GET_HISTORICO_PAGO_ADYEN: 'PagoAdyen/historico',
  GET_ULTIMO_PAGO_ADYEN: 'PagoAdyen/ultimo',
  POST_PAGO_ADYEN_REFUND: 'PagoAdyen/refund',
  GET_CONFIG_URL_REDSYS_PAYMENT: 'PagoConfig/GetUrlRedsysPayment',
  GET_CONFIG_URL_CECA_PAYMENT: 'PagoConfig/GetUrlCecaPayment',

  // Paises Info
  GET_PAISES_INFO: 'PaisInfo/paisesInfo',
  GET_PAISES_INFO_FILTERED: 'PaisInfo/paisesInfo/filtered',

  // Reemplazar texto
  GET_REEMPLAZAR_TEXTO: 'Reemplazar/reemplazarTexto',

  // Productos en caja
  GET_PRODUCTOS_EN_CAJA: 'Producto/productos/getProductosEnCaja',
  PATCH_PRODUCTOS_EN_CAJA: 'Producto/productos/setProductoEnCaja',

  // Url Historial Posicion
  GET_URL_HISTORIAL_POSICIONES_BY_CATEGORIA:
    'UrlHistorialPosicion/urlHistorialPosicionesByCategoriaId',
  POST_URL_HISTORIAL_POSICIONES: 'UrlHistorialPosicion/urlHistorialPosiciones',
  PATCH_URL_HISTORIAL_GUARDAR_POSICIONES: 'Url/urls/ordenarUrl',
  DELETE_URL_HISTORIAL_POSICIONES: 'UrlHistorialPosicion',
  GET_URL_HISTORIAL_POSICIONES: 'UrlHistorialPosicion/urlHistorialPosiciones',

  // Monedas
  GET_MONEDA_BY_ID: 'Moneda',

  // Transportistas
  TRANSPORTISTA: 'Transportista',
  VACACIONES_TRANSPORTISTA: 'Transportista/Vacaciones',
  REORDENAR_TRANSPORTISTAS: 'Transportista/Reordenar',
  RECORRIDO_HISTORICO: 'RecorridoHistorico',
  COMENTARIOS_TRANSPORTISTA: 'TransportistaComentarios',
  COMENTARIOS_TRANSPORTISTA_HORARIO: 'TransportistaComentarios/Horario',
  VISIBLE_TRANSPORTISTA: 'TransportistaVisible',
  VISIBLE_TRANSPORTISTA_MOSTRAR_OCULTAR_TODOS: 'TransportistaVisible/MostrarOcultarTodos',

  // Generar site map
  POST_SHOPPING_AGGREGATOR_GENERAR_SITE_MAP_BACKGROUND: 'GenerarSiteMap/GenearSiteMapBackGround',
  GET_SHOPPING_AGGREGATOR_SITE_MAP_FICHEROS: 'GenerarSiteMap/ficheros',

  // Productos Mas Vendidos
  GET_PRODUCTOS_MAS_VENDIDOS: 'ProductosMasVendidos',
  POST_PRODUCTOS_MAS_VENDIDOS: 'Venta/createProductosMasVendidos',
  DELETE_PRODUCTOS_MAS_VENDIDOS: 'ProductosMasVendidos',
  GET_TOP_VENTAS: 'TopVentas',
  
  // Jobs
  GET_JOBS_LOG: 'Log',
  GET_JOB_CONFIGS: 'JobConfig',
  PUT_JOB_CONFIG_CRON: 'JobConfig',
  PUT_JOB_CONFIG_ACTIVO: 'JobConfig',
  GET_JOB_LOGS_PAGINATED: 'Log/job',
  GET_JOB_CICLOS_PAGINATED: 'Log/job',
  GET_LOGS_BY_PROCESO: 'Log/proceso',

  // Estados de Usuario
  GET_ESTADOS_USUARIOS: 'EstadoUsuario/estadosUsuarios',
  GET_ESTADO_USUARIO_BY_ID: 'EstadoUsuario/estadosUsuarios',
  PUT_ESTADO_USUARIO_UPDATE: 'EstadoUsuario/estadosUsuarios',
  POST_ESTADO_USUARIO_INSERT: 'EstadoUsuario/estadosUsuarios',
  DELETE_ESTADO_USUARIO_BY_ID: 'EstadoUsuario/estadosUsuarios',

  // Control diseño de mantas
  GET_CONTROL_DISENO_MANTAS_BY_VENTAID: 'Venta/getControlDisenoMantas',
  POST_VENTA_SET_ITEM_FABRICADO: 'Venta/setVentaItemsFabricados',

  // Roles
  GET_ROLES_LISTA: 'Rol/roles',
  GET_ROLES_FILTERED: 'Rol/roles/filtered',
  GET_ROLES_BY_ID: 'Rol/roles',
  POST_ROLES_INSERT: 'Rol/roles',
  PUT_ROLES_UPDATE: 'Rol/roles',
  DELETE_ROLES_BY_ID: 'Rol/roles',
  POST_ROLES_SET_MENUS: 'Rol/roles/updateMenus',

  // Menus
  GET_MENU_ADMIN_ALL: 'Menu/menus/menuAdmin',

  // Permisos de usuarios
  GET_PERMISOS_USUARIOS: 'UsuarioPermisos/permisos',
  POST_PERMISOS_USUARIOS: 'UsuarioPermisos/permisos',
  GET_PERMISOS_USUARIOS_MENU: 'UsuarioPermisos/permisos/menuAdmin',
  GET_PERMISOS_USUARIOS_MENUKEY: 'UsuarioPermisos/permisos/menuKeys',

  // Firewall Ips
  GET_FIREWALLIPS_LISTA: 'FirewallIp/firewallIps',
  POST_FIREWALLIPS_INSERT: 'FirewallIp/firewallIps',
  DELETE_FIREWALLIPS_BY_ID: 'FirewallIp/firewallIps',
  GET_FIREWALLIPS_IP_REMOTA: 'FirewallIp/firewallIps/getRemoteIP',

  // Sync
  GET_ACTIVIDAD_SYNC: 'Actividad',
  GET_VENTA_SYNC_STATUS: 'VentaSyncStatus',
  GET_VENTA_SYNC_STATUS_ESTADISTICAS: 'VentaSyncStatus/estadisticas',
  GET_ERRONEO_SYNC: 'Erroneo',
  GET_INSTANCIA_SYNC: 'ManejadorInstancia',
  UPDATE_ERRONEO_SYNC: 'Erroneo',
  GET_PROCESADO_SYNC: 'Procesado',
  UPDATE_INSTANCIA_SYNC: 'ManejadorInstancia',

  // AppSettings
  GET_ALL_APPSETTINGS: 'AppSettings/appSettings',
  GET_APPSETTING_BY_KEY: 'AppSettings/appSettings',
  SET_APPSETTINGS: 'AppSettings/appSettings/setAllAppSettings',

  // Restricciones entrega
  GET_RESTRICCIONES_ENTREGA: 'RestriccionEntrega',
  POST_RESTRICCIONES_ENTREGA_BULK: 'RestriccionEntrega/bulk',
  POST_RESTRICCIONES_ENTREGA: 'RestriccionEntrega',

  // Cache personalizacion cliente
  DELETE_CACHE_PERSONALIZACION_CLIENTE_BY_PRODUCTO_ID: 'PersonalizacionCache/deleteProductoPersonalizado',

  // Cache aggregator
  DELETE_CACHE_BY_KEY: 'Cache/key',
  DELETE_CACHE_BY_PREFIX: 'Cache/prefix',
  DELETE_CACHE_BY_TAG: 'Cache/tag',
  DELETE_CACHE_BY_URL: 'Cache/url',
  CACHE_LOAD_BALANCER: 'Cache/loadbalancer',
  CACHE_LOAD_BALANCER_TOGGLE: 'Cache/loadbalancer/toggle',

  // Reviews
  GET_REVIEWS_PENDIENTES: 'Review/pending',
  PUT_REVIEWS_APROBAR: 'Review/aprobar',
  POST_REVIEWS_LOTE: 'Review/lote',
}
